import { Link } from "react-router-dom";
import "./Footer.css";
function Footer() {
  return (
    <>
      <section className="newletter">
        <div className="container flexSB"></div>
      </section>
      <footer>
        <div className="container_padding row row-cols-1 row-cols-md-4">
          <div className="box_logo">
            <h1 className="box_logo_h1">Orange Tree Education</h1>
            <p className="box_logo_p">Learn to earn...</p>
          </div>
          <div className="box_link">
            <h3>Explore</h3>
            <ul>
              <li>
                <Link to="/About" className="linkAchor">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/Courses" className="linkAchor">
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/Team" className="linkAchor">
                  Team
                </Link>
              </li>
              <li>
                <Link to="/Contact" className="linkAchor">
                  Contact us
                </Link>
              </li>
            </ul>
          </div>
          <div className="box_link">
            <h3>Top Courses</h3>
            <ul>
              <li>Java</li>
              <li>Python</li>
              <li>PHP</li>
              <li>Web Programming</li>
            </ul>
          </div>
          <div className="box_link">
            <h3>Contact Us</h3>
            <ul>
              <li id="address">
                <i className="fa fa-map"></i>
                <a href="/Contact"  className="linkAchor">
                  Near Dolphin Logic Systems Private Limited, R. T. Road, Gond
                  Plot, Wardha - 442001
                </a>
              </li>
              <li>
                <i className="fa fa-phone-alt"></i>
                <a className="phoneNumber" href="tel:+91 9766698067">
                  9766698067
                </a>
                ,
                <a className="phoneNumber" href="tel:+91 9325253667">
                   9325253667
                </a>
              </li>
              <li>
                <i className="fa fa-paper-plane"></i>
                <a
                  className="linkAchor"
                  href="mailto:education.orangetree@gmail.com">
                  education.orangetree@gmail.com
                </a>
              </li>
              <li>
                <i className="fa fa-paper-plane"></i>
                <a
                  className="linkAchor"
                  target="blank"
                  href="http://www.orangetree.guru">
                  www.orangetree.guru
                </a>
              </li>
            </ul>
          </div>
        </div>
        <p id="copyright">
          Copyright &copy; 2023 All rights reserved |{" "}
          <i className="fa fa-heart"></i> Powered by Dolphin Logic Systems Private Limited
        </p>
      </footer>
    </>
  );
}
export default Footer;
